import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="precio" className="py-24 bg-slate-900 relative overflow-hidden text-center" data-id="element-13">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-primary/10 rounded-full blur-3xl pointer-events-none" data-id="element-14" />

      <div className="container mx-auto px-4 relative z-10 max-w-4xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-16">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-17">
            Recupera a tu hijo hoy mismo
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-18">
            No esperes a que la adolescencia lo haga imposible. El mejor momento
            para actuar fue ayer. El segundo mejor momento es ahora.
          </p>

          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 inline-block w-full max-w-md mx-auto mb-10" data-id="element-19">
            <div className="flex items-end justify-center mb-2" data-id="element-20">
              <span className="text-5xl font-bold text-white" data-id="element-21">$6.39</span>
            </div>
            <p className="text-brand-primary font-medium text-sm mb-6" data-id="element-22">
              Oferta especial de lanzamiento
            </p>

            <Button size="xl" fullWidth className="text-lg font-bold shadow-xl shadow-brand-primary/20 mb-4" onClick={() => window.open('https://www.digitalgroupfl.com/cart/52737771602031:1', '_blank')} data-id="element-23">
              DESCARGAR AHORA
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-24" />
            </Button>

            <div className="flex items-center justify-center text-xs text-slate-400 space-x-4" data-id="element-25">
              <span className="flex items-center" data-id="element-26">
                <Lock className="w-3 h-3 mr-1" data-id="element-27" /> Pago Seguro
              </span>
              <span className="flex items-center" data-id="element-28">
                <ShieldCheck className="w-3 h-3 mr-1" data-id="element-29" /> Garantía de 30 días
              </span>
            </div>
          </div>

          <p className="text-slate-500 text-sm" data-id="element-30">
            Si no ves resultados medibles en 30 días, te devolvemos el 100% de
            tu dinero. Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}